import image1 from '../assets/carousel/1.jpg'
import image2 from '../assets/carousel/2.jpg'
import image3 from '../assets/carousel/3.jpg'
import image4 from '../assets/carousel/4.jpg'
import image5 from '../assets/carousel/5.jpg'
import image6 from '../assets/carousel/6.jpg'

const images = [image1, image2, image3, image4, image5, image6]

export default images;